module.exports = __webpack_public_path__ + "img/info-circle-filled.9d087ca7.svg";